import { render } from "./BulkUploadSuppliers.vue?vue&type=template&id=27b5f958&scoped=true"
import script from "./BulkUploadSuppliers.vue?vue&type=script&lang=js"
export * from "./BulkUploadSuppliers.vue?vue&type=script&lang=js"

import "./BulkUploadSuppliers.vue?vue&type=style&index=0&id=27b5f958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b5f958"]])

export default __exports__